import { Result } from '../../../common-models/Result';
import { HttpServiceBase } from '../../../common-services/Http/HttpServiceBase';
import { SaveRecipeInput } from './SaveRecipeInput';
import { SaveRecipeOutput } from './SaveRecipeOutput';

export class SaveRecipeService extends HttpServiceBase {

  handle = (input: SaveRecipeInput): Promise<Result<SaveRecipeOutput> | null> => {
    const promise = this.http.post<Result<SaveRecipeOutput>, SaveRecipeInput>(`${this.baseUrlSislogApi}/v2/recipe`, input);
    return promise;
  }
}